import { render, staticRenderFns } from "./ExpensesEvolutionTable.vue?vue&type=template&id=2688fd19&scoped=true"
import script from "./ExpensesEvolutionTable.vue?vue&type=script&lang=js"
export * from "./ExpensesEvolutionTable.vue?vue&type=script&lang=js"
import style0 from "./ExpensesEvolutionTable.vue?vue&type=style&index=0&id=2688fd19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688fd19",
  null
  
)

export default component.exports